import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContentTypeHeaderFactoryService {

  constructor() { }

  createHeader(contentType) {
    const header = {};
    header["Content-Type"] = contentType;
    return header;
  }
}
